import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { FaTrashAlt } from 'react-icons/fa';
import { NIL as uuidNIL } from 'uuid';
import * as Motion from 'motion/react';
import Loader from '../../components/Loaders';
import ProtocolEditor from '../../components/ProtocolEditor';
import useDialogBox from '../../hooks/useDialogBox';
import { deleteProtocol, getProtocol } from '../../api/v1/protocols';
import { animationStaggeredItem } from '../../animations';
import '../../styles/screen.scss';

const { motion } = Motion;


const Protocol = () => {
  const [protocol, setProtocol] = useState({});
  const [responseToast, setResponseToast] = useState('');
  const [isLoading, setIsLoading] = useState(true);
  const { resetDialogBox, setDialogBox } = useDialogBox();
  const navigate = useNavigate();
  const { protocolId } = useParams();

  const loadProtocol = async (protocolId) => {
    const result = await getProtocol(protocolId);

    setProtocol(result?.data);
  };

  const confirmDeleteProtocol = async (protocolId) => {
    setDialogBox({
      title: 'Delete Protocol',
      content: <p>Do you want to delete protocol <b>{protocol?.name || protocolId}</b>?</p>,
      actions: [
        { title: 'Delete Protocol', type: 'danger', action: async () => await handleDeleteProtocol(protocolId) },
        { title: 'Cancel', type: 'cancel', action: () => resetDialogBox() }
      ]
    });
  };

  const handleDeleteProtocol = async (protocolId) => {
    await deleteProtocol(protocolId);
    resetDialogBox();

    navigate(-1);
  };

  const onSaveProtocol = async (message) => {
    setResponseToast(message);
  };

  useEffect(() => {
    (async () => {
      await loadProtocol(protocolId);
      setIsLoading(false);
    })();
  }, [protocolId]);

  useEffect(() => {
    if (responseToast.length) {
      setTimeout(() => {
        setResponseToast('');
      }, 5000);
    }
  }, [responseToast]);

  return (
    <>
      <Motion.AnimatePresence>
        {isLoading && <Loader/>}
      </Motion.AnimatePresence>

      {
        responseToast && <div className={'response-toast'}>{responseToast}</div>
      }

      <div className="screen-navigation">
        <button className="screen-back-button" onClick={() => navigate(-1)}>&larr; Go Back</button>
      </div>

      <motion.div variants={animationStaggeredItem} className="screen-header">
        <div className="screen-title-wrapper">
          <div>
            <h2 className="screen-title">
              {
                protocol?.name ?
                  protocol?.name :
                  'Protocol'
              }
            </h2>

            <p className="screen-subtitle">
              <b>Protocol ID:</b> {protocol?.id}
            </p>
          </div>
        </div>

        {
          protocol?.id !== uuidNIL &&
          <button className="screen-header-button danger" onClick={() => confirmDeleteProtocol(protocolId)}>
            <FaTrashAlt/>
            Delete Protocol
          </button>
        }
      </motion.div>

      <motion.div variants={animationStaggeredItem} className="screen-section">
        <p>
          <b>Is Template:</b>
          &nbsp;
          {protocol?.isTemplate ? 'Yes' : 'No'}
        </p>

        <p>
          <b>Last Updated:</b>
          &nbsp;
          {protocol?.updatedAt}
        </p>
      </motion.div>

      <motion.div variants={animationStaggeredItem} className="screen-section flex-3">
        <ProtocolEditor protocolId={protocolId} onSaveProtocol={onSaveProtocol} initialValue={protocol?.protocol}/>
      </motion.div>
    </>
  )
};

export default Protocol;
